interface OnboardingStepperProps {
	currentStep: number
	totalSteps?: number
}

export const OnboardingStepper = ({
	currentStep,
	totalSteps = 4
}: OnboardingStepperProps) => {
	const steps = Array.from({ length: totalSteps }, (_, i) => i + 1)

	return (
		<div className="flex items-center justify-center gap-[6px]">
			{steps.map((step) => {
				let colorClass = 'bg-t-step-inactive'
				if (step < currentStep) {
					colorClass = 'bg-brand'
				} else if (step === currentStep) {
					colorClass = 'bg-brand-200'
				}

				return (
					<div
						className={`h-[8px] md:w-[100px] w-[64px] rounded-full transition-colors duration-300 ${colorClass}`}
						key={step}
					/>
				)
			})}
		</div>
	)
}
